<template>
  <div class="lkw100-egame">
    <div class="game-wrap egame">
      <div class="search">
        <b-form @submit.prevent="searchGame">
          <b-input-group size="lg" class="mb-2">
            <b-input-group-prepend is-text @click="searchGame">
              <i class="icon icon-search"></i>
            </b-input-group-prepend>
            <b-form-input
              type="search"
              placeholder="Search"
              v-model="SearchValue"
              @blur.native="searchBlur"
            ></b-form-input>
          </b-input-group>
        </b-form>
      </div>
      <h1 class="title"><span class="bg">{{ title }}</span><q class="dn fg">{{title}}</q></h1>

      <b-overlay :show="GameLoading">
        <div class="game-list more">
          <template v-for="(list, index) in GameList">
            <b-button :class="`${list.className} ${list.maintain} ${slotGame}`" :data-text="$t('store.uphold_ing')">
              <div class="game-name">
                <span>{{ list.name }}</span>
              </div>
              <div class="game-star"><i class="icon icon-star"></i></div>
              <div class="game-new"><i class="icon icon-new"></i></div>
              <div class="game-soon">
                <b
                  >{{ $t("store.soon1")
                  }}<q>{{ $t("store.soon2") }}</q
                  ><q>{{ $t("store.soon3") }}</q
                  >{{ $t("store.soon4") }}</b
                >
              </div>
              <div class="game-uphold">
                <i class="img img-uphold"
                  ><q>{{ $t("store.uphold_ing") }}</q></i
                >
              </div>
              <div class="game-btn-group">
                <a class="game-btn lknowbtn" @click="playGame(categoryId, list.id)">
                  {{ $t("store.btn.play_game_now") }}<i class="icon icon-arrowleft"></i>
                </a>
                <a v-if="list.hasTryGame" class="game-btn" @click="tryGame(categoryId, list.id)">
                  {{ $t("store.btn.free_try_play") }}<i class="icon icon-arrowleft"></i>
                </a>
              </div>
              <i :class="`product_${list.product_id}`"></i>
              <img class="game-img" v-lazy="list.imgPath" :alt="list.name" />
              <div class="egameDecTag" v-if="list.hot">
                <span class="textNew text">NEW</span>
                <span class="textHot text">HOT</span>
              </div>
            </b-button>
          </template>
        </div>
        <template v-slot:overlay>
          <div class="loading text-center">
            <div class="lds-square"></div>
            <div class="text">Loading...</div>
          </div>
        </template>
      </b-overlay>

      <div class="overflow-auto game-page">
        <b-pagination
          v-model="Current"
          :total-rows="TableSetting.PageSetting.Total"
          :per-page="TableSetting.PageSetting.PageSize"
        />
      </div>
    </div>

  </div>
</template>
<script>
  import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
  export default {
    layout: "desktop",
    transition: "bounce",
    GameLoading: true,
    props: {
      categoryId: { type: Number, default: 3 },
      title: { type: String, default: '' },
    },
    data() {
      return {
        SearchValue: "",
        Current: 1,
        slotGame: "slot_game"
      };
    },
    methods: {
      audioClick() {
        if(this.DEF_webStyle === 'jdf' || this.DEF_webStyle === 'fl8n' || this.DEF_webStyle === 'fl88' || this.DEF_webStyle === 'kb88' || this.DEF_webStyle === 'jh8'){
          if(this.IsAudio) {
            const audio = document.querySelector("#beep");
            const context = new AudioContext();
            function isIOS() {
              return /iPhone|iPad|iPod/i.test(navigator.userAgent);
            };
            if (context.state === 'suspended') {
              context.resume().then(() => {});
            };
            if (isIOS()) {
              setTimeout(function() {
                audio.muted = false;
                audio.play();
              }, 200);
            } else {
              audio.muted = false;
              audio.play();
            };
          }
        };
      },
      init() {
        if (this.SearchValue != this.GameSelect)
          this.SearchValue = this.GameSelect;
      },
      playGame(ProductId, GameId) {
        this.audioClick();
        if (this.$auth.$state.loggedIn === false) {
          this.$router.push({ name: 'account-login', params: null, query: null });
          return;
        }

        let GameData = this.GameList.find((element) => element.id === GameId);
        if (!this.ShowTransferModal) {
          window.open(GameData.playGameUrl);
          return;
        }

        this.setPlayGameData({ WalletCode: GameData.wallet_code, Url: GameData.playGameUrl });
        this.$nextTick(() => this.$root.$emit("bv::toggle::modal", "modalExchPoint", "#btnToggle"));
      },
      tryGame(ProductId, GameId) {
        this.audioClick();
        if (this.$auth.$state.loggedIn === false)
          this.$router.push({ name: 'account-login', params: null, query: null });
        else {
          let GameData = this.GameList.find((element) => element.id === GameId);
          window.open(GameData.tryGameUrl);
        }
      },
      eslotgame(){
        if(this.DEF_webStyle === 'fl88'){
          this.slotGame = "else"
        }
      },
      searchGame() {
        this.audioClick();
        this.setGameSelect(this.SearchValue);
        this.$nextTick(() => {
          if (this.ClassificationId != 0 && this.SearchValue != "")
            this.setClassificationId(0);
          else if (this.Current != 1) this.setTableSettingCurrent(1);
          else this.getGameList();
        });
      },
      searchBlur() {
        if (this.SearchValue == '' && this.GameSelect != this.SearchValue)
          this.searchGame();
      },
      ...mapMutations("game", ["setTableSettingCurrent", "setGameSelect", "setClassificationId", "setPlayGameData"]),
      ...mapActions("game", ["getGameList", "getTryGame", "getPlayGame"]),
    },
    mounted() {
      this.init();
      this.eslotgame();
      this.$nextTick(function () {
        const sound_btn = document.getElementById('sound_btn');
        if (sound_btn) {
          sound_btn.click();
        }
      });
    },
    watch: {
      Current(value) {
        this.setTableSettingCurrent(value);
        this.$nextTick(() => this.getGameList());
      },
      SearchValue(value) {
        // this.setGameSelect(value);
        // this.$nextTick(() => {
        //   if (this.ClassificationId != 0 && value != "")
        //     this.setClassificationId(0);
        //   else if (this.Current != 1) this.setTableSettingCurrent(1);
        //   else this.getGameList();
        // });
      },
      "TableSetting.PageSetting.Current"(value) {
        this.Current = value;
      },
    },
    computed: {
      DEF_webStyle() {
        return process.env.DEF_webStyle || 'default';
      },
      ...mapState(['WebSetting', 'IsAudio']),
      ...mapState("game", ["TableSetting", "ClassificationId", "GameSelect", "GameLoading", "ProductId"]),
      ...mapGetters(["Product"]),
      ...mapGetters("game", ["GameList"]),
      ...mapGetters('webSetting', ['ShowTransferModal'])
    },
  };
</script>
